import { CustomTrail } from "../../../types/tour";

export const SET_TRAILS = "SET_TRAILS";
export const SET_SUGGESTED_TRAILS = "SET_SUGGESTED_TRAILS";
export const SET_CURRENT_TRAIL = "SET_CURRENT_TRAIL";
export const NAVIGATE_TO_TRAIL = "NAVIGATE_TO_TRAIL";
export const RESET_CURRENT_TRAIL = "RESET_CURRENT_TRAIL";

interface ActionTypes {
  SET_TRAILS: CustomTrail;
  SET_SUGGESTED_TRAILS: CustomTrail[];
  SET_CURRENT_TRAIL: number;
  NAVIGATE_TO_TRAIL: { trailId: string; trailIndex: number };
  RESET_CURRENT_TRAIL: null;
}

type ActionPayload<T extends keyof ActionTypes> = T extends "SET_TRAILS"
  ? CustomTrail
  : T extends "SET_SUGGESTED_TRAILS"
  ? CustomTrail[]
  : T extends "SET_CURRENT_TRAIL"
  ? number
  : T extends "NAVIGATE_TO_TRAIL"
  ? { trailId: string; trailIndex: number }
  : T extends "RESET_CURRENT_TRAIL"
  ? null
  : never;

export interface MessageAction<
  T extends keyof ActionTypes = keyof ActionTypes
> {
  type: T;
  payload: ActionPayload<T>;
}

export function setTrails(trails: CustomTrail): TrailsActionsTypes {
  return {
    type: SET_TRAILS,
    payload: trails,
  };
}

export function setSuggestedTrails(
  suggestedTrails: CustomTrail[]
): TrailsActionsTypes {
  return {
    type: SET_SUGGESTED_TRAILS,
    payload: suggestedTrails,
  };
}

export function setCurrentTrail(trailIndex: number): TrailsActionsTypes {
  return {
    type: SET_CURRENT_TRAIL,
    payload: trailIndex,
  };
}

export function navigateToTrail(
  trailId: string,
  trailIndex: number
): TrailsActionsTypes {
  return {
    type: NAVIGATE_TO_TRAIL,
    payload: { trailId, trailIndex },
  };
}

export function resetCurrentTrail(): TrailsActionsTypes {
  return {
    type: RESET_CURRENT_TRAIL,
    payload: null,
  };
}

export type TrailsActionsTypes = MessageAction;
